import React from 'react';
// import './navbar.css'
import Logo from '../../../images/logo.png'

export default function Navbar() {
  return (
    <div className='absolute w-full border-t-4 border-[#fdb814] bg-white '>
      <div className='border-b border-gray-300'>
        <div className='flex mx-auto'>
        <span className='py-4 px-4 text-xl font-semibold text-[#fdb814]'>
          <img
            src={Logo}
            alt="Logo"
            height={50}
            width={50}
            className='inline-block align-middle mr-2'  // Added margin and vertical align
          />
          <span className='align-middle'>PROVIDUS API SANDBOX</span>
        </span>
        </div>
      </div>
    </div>
  );
}